import { Col } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { InternalLink } from "common/components/InternalLink/InternalLink";
import { getString } from "common/uistringlabels/uiStringUtils";
import React from "react";
import { FC } from "react";

const NoAiTools: FC = () => {
  return (
    <Col gridGap="S300">
      <Text fontSize="T200" fontWeight="regular">
        {getString("aiForMe.noTools")}{" "}
        <InternalLink to={"/aiforme/contribute"}>{getString("aiForMe.contributeTool")}</InternalLink>
      </Text>
    </Col>
  );
};

export default NoAiTools;
